/**
 * Shared axios instance for the frontend.
 *
 * - baseURL pulled from VITE_API_URL at build time; defaults to the
 *   local dev backend so `npm run dev` works without a .env.
 * - Request interceptor reads `token` from localStorage and stamps
 *   `Authorization: Bearer <token>` on every outbound call. The
 *   backend's middleware/auth.js does the verify; on 401 the caller
 *   is responsible for triggering a re-login (no global handler here
 *   to avoid double-redirects when components do their own retry).
 *
 * Default-exported because every consumer treats it as a singleton.
 */

import axios from 'axios';
import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

const api: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
